export type Neighborhood =
  | 'andersonville'
  | 'bucktown'
  | 'gold-coast'
  | 'lakeview'
  | 'lincoln-park'
  | 'logan-square'
  | 'old-town'
  | 'river-north'
  | 'south-loop'
  | 'streeterville'
  | 'west-loop'
  | 'wicker-park';

export type DealType = 'happy-hour' | 'trivia' | 'bingo' | 'drag' | 'comedy' | 'dog-friendly' | 'patio';

export type DayOfWeek = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';

export interface BarDeal {
  id: string;
  barName: string;
  neighborhood: Neighborhood;
  dealType: DealType;
  title: string;
  description: string;
  days: DayOfWeek[];
  time: string;
  address: string;
  sourceUrl?: string;
  barWebsite?: string;
  instagramUrl?: string;
  reservationUrl?: string;
  websiteStatus?: 'working' | 'broken' | 'unreliable' | null;
}

export const NEIGHBORHOODS: { id: Neighborhood; name: string; description: string }[] = [
  { id: 'andersonville', name: 'Andersonville', description: 'Swedish roots & LGBTQ+ nightlife' },
  { id: 'bucktown', name: 'Bucktown', description: 'Hip cocktail bars & gastropubs' },
  { id: 'gold-coast', name: 'Gold Coast', description: 'Upscale lounges & rooftop bars' },
  { id: 'lakeview', name: 'Lakeview', description: 'Wrigleyville energy & nightlife' },
  { id: 'lincoln-park', name: 'Lincoln Park', description: 'Laid-back neighborhood spots' },
  { id: 'logan-square', name: 'Logan Square', description: 'Cocktail dens & dive bars' },
  { id: 'old-town', name: 'Old Town', description: 'Historic bars & comedy clubs' },
  { id: 'river-north', name: 'River North', description: 'Upscale lounges & late nights' },
  { id: 'south-loop', name: 'South Loop', description: 'Sports bars & neighborhood gems' },
  { id: 'streeterville', name: 'Streeterville', description: 'Mag Mile bars & hotel lounges' },
  { id: 'west-loop', name: 'West Loop', description: 'Trendy cocktail bars & restaurants' },
  { id: 'wicker-park', name: 'Wicker Park', description: 'Indie bars & restaurant row' },
];

export const DEAL_TYPES: { id: DealType; label: string; icon: string }[] = [
  { id: 'happy-hour', label: 'Happy Hour', icon: '🍻' },
  { id: 'trivia', label: 'Trivia', icon: '🧠' },
  { id: 'bingo', label: 'Bingo', icon: '🎱' },
  { id: 'comedy', label: 'Comedy', icon: '🎤' },
  { id: 'drag', label: 'Drag', icon: '👑' },
  { id: 'dog-friendly', label: 'Dog Friendly', icon: '🐶' },
  { id: 'patio', label: 'Patio', icon: '☀️' },
];

export const DAYS: { id: DayOfWeek; short: string; full: string }[] = [
  { id: 'monday', short: 'Mon', full: 'Monday' },
  { id: 'tuesday', short: 'Tue', full: 'Tuesday' },
  { id: 'wednesday', short: 'Wed', full: 'Wednesday' },
  { id: 'thursday', short: 'Thu', full: 'Thursday' },
  { id: 'friday', short: 'Fri', full: 'Friday' },
  { id: 'saturday', short: 'Sat', full: 'Saturday' },
  { id: 'sunday', short: 'Sun', full: 'Sunday' },
];
